


































import { GridItem, SerialNumber } from '@/types';
import Vue, { PropType } from 'vue';

import { CellGrid, Cell } from '@/components/CellGrid';
import SnTooltip from './SerialNumberTooltip.vue';

export default Vue.extend({
  components: {
    Cell,
    CellGrid,
    SnTooltip,
  },

  props: {
    rows: {
      type: Number,
      default: 0,
    },
    columns: {
      type: Number,
      default: 0,
    },
    orientation: {
      type: String,
      default: 'HORIZONTAL',
    },
    value: {
      type: Array as PropType<GridItem[]>,
      default: () => [],
    },
    serialnumbers: {
      type: Array as PropType<SerialNumber[]>,
      default: () => [],
    },
    patterns: {
      type: Array as PropType<string[]>,
      default: () => [],
    },
  },

  computed: {
    tileColor() {
      return (item: GridItem): string => {
        if (!item.value) {
          return 'grey lighten-2';
        }

        const sn = this.serialnumbers[item.index - 1];

        if (!sn) {
          return 'grey';
        }

        if (!this.isValidSerialnumber(sn)) {
          return 'error';
        }

        return 'success';
      };
    },

    isValidSerialnumber() {
      return (sn: SerialNumber): boolean =>
        this.patterns.some(
          pattern => sn.serialNumber && sn.serialNumber.match(new RegExp(pattern)),
        );
    },
  },
});
